import {
  DataVersion,
  IncidentDetail,
  IncidentProduct,
} from '@hakimo-ui/hakimo/types';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useIncidentDetail(
  alarmId: number | string | undefined,
  product: IncidentProduct,
  dataVersion?: DataVersion
) {
  const searchParams = new URLSearchParams({
    alarm_id: String(alarmId ?? ''),
    product,
  });
  const request = new Request(
    `/v2/orm/location_incidents/detail?${searchParams.toString()}`
  );
  withDataVersion(request, dataVersion);

  return useAuthenticatedRequest<IncidentDetail>(request, {
    queryKey: ['incidentDetail', { alarmId, product, dataVersion }],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    enabled: !!alarmId,
  });
}

export default useIncidentDetail;
